import { providerRequestsTyped } from "@/api/(requests)/providerTyped";
import type { UUID } from "@/core/types";

export type DeleteNoteVariables = {
  noteId: UUID;
  patientId: UUID;
};

export async function deleteProgressNote({
  noteId,
  patientId,
}: DeleteNoteVariables): Promise<void> {
  return providerRequestsTyped.delete_progress_note({
    body: { id: noteId },
    urlParams: { patientId },
  });
}
